import offlinePaymentService from "./axiosInstances/offlinePayment";
import authService from "./axiosInstances/auth";
import appService from "./axiosInstances/application";

import { store } from "store";

export const getOrderDetails = (billingRequestId, tenantCode) => {
  return offlinePaymentService.get(
    `/admin-utility/tenant/${tenantCode}/user-info-details/billing-request-id/${billingRequestId}`
  );
};

export const fetchUserDetailsByEmail = (email) => {
  return authService.get(`/apis/auth/v4/accounts/by-email?email=${email}`);
};

// Get Prism token using logged-in user's token
export const getPrismToken = async () => {
  try {
    const response = await appService.get("/api/v1/prism/token", {});

    return response.data; // The API returns the token directly as text
  } catch (error) {
    console.error("Error getting Prism token:", error);
    throw error;
  }
};

// Create Phoenix user after GraphQL user selection/creation
export const createPhoenixUser = async (userData) => {
  try {
    // Get Prism token for kcToken
    const prismToken = await getPrismToken();

    if (!prismToken) {
      throw new Error("No Prism token available");
    }

    const response = await authService.post(
      `apis/vpc-only/auth/v6/create-phoneix-user?kcToken=${prismToken}`,
      {
        prismId: userData.id,
        iamAuthId: userData.iamAuthId || null,
        mobileNumber: userData.mobile,
        mobile: userData.mobile,
        given_name: userData.firstName,
        isEmailVerify: userData.isEmailVerified || false,
        isMobileVerify: userData.isMobileVerify || false,
        name: `${userData.firstName} ${userData.lastName}`,
        isd: userData.isd || "+91",
        family_name: userData.lastName,
        email: userData.email,
        isPhoneixUser: true,
      }
    );

    console.log("Phoenix user creation response:", response.data);
    return response.data; // Return the response data including the id field
  } catch (error) {
    console.error("Error creating Phoenix user:", error);
    throw error;
  }
};

export const createUser = async (userData) => {
  try {
    // First get the Prism token
    const prismToken = await getPrismToken();

    return authService.post(
      "/apis/tenant/KNLGHT/v1/offline-signup",
      {
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        emailVerified: true,
        identifier: "email",
        phoneNumber: userData.phoneNumber,
        phoneVerified: true,
      },
      {
        headers: {
          Authorization: `Bearer ${prismToken}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (error) {
    console.error("Error in createUser:", error);
    throw error;
  }
};

export const saveTransferOwnership = (userData) => {
  return offlinePaymentService.post(`/transfer/ownership`, userData);
};

// Mock API to simulate api call for updating field values
export const updateFieldValue = (section, field, value) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        status: 200,
        data: {
          section,
          field,
          value,
          timestamp: new Date().toISOString(),
        },
      });
    }, 800);
  });
};
